/* eslint-disable @typescript-eslint/no-restricted-imports */
import clsx, { type ClassValue } from 'clsx';
import { twMerge } from '@bbkShared/utils/css-utils';

export const cn = (...args: ClassValue[]) => twMerge(clsx(args));

export { type ClassValue as Argument, cn as cs };
